import React, { useEffect, useState } from 'react';
import { Row, Col, Card, Statistic, Spin } from 'antd';
import {
  KeyOutlined,
  DesktopOutlined,
  CheckCircleOutlined,
  PercentageOutlined
} from '@ant-design/icons';
import axios from 'axios';
import { useAuth } from '../contexts/AuthContext';

const Dashboard = () => {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const { getAuthHeaders, API_BASE_URL } = useAuth();

  useEffect(() => {
    fetchStats();
  }, []);

  const fetchStats = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/stats`, {
        headers: getAuthHeaders()
      });
      if (response.data.success) {
        setStats(response.data.data);
      }
    } catch (error) {
      console.error('获取统计数据失败:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div style={{ textAlign: 'center', padding: 50 }}>
        <Spin size="large" />
      </div>
    );
  }

  return (
    <div>
      <h2>数据概览</h2>
      <Row gutter={16}>
        <Col span={6}>
          <Card>
            <Statistic
              title="总序列号数"
              value={stats?.total_serials || 0}
              prefix={<KeyOutlined />}
            />
          </Card>
        </Col>
        <Col span={6}>
          <Card>
            <Statistic
              title="有效序列号"
              value={stats?.active_serials || 0}
              valueStyle={{ color: '#3f8600' }}
              prefix={<CheckCircleOutlined />}
            />
          </Card>
        </Col>
        <Col span={6}>
          <Card>
            <Statistic
              title="已激活设备"
              value={stats?.total_fingerprints || 0}
              prefix={<DesktopOutlined />}
            />
          </Card>
        </Col>
        <Col span={6}>
          <Card>
            <Statistic
              title="激活使用率"
              value={stats?.usage_rate || 0}
              suffix="%"
              precision={2}
              prefix={<PercentageOutlined />}
            />
          </Card>
        </Col>
      </Row>

      <Row gutter={16} style={{ marginTop: 24 }}>
        <Col span={12}>
          <Card title="激活统计">
            <Statistic
              title="总激活配额"
              value={stats?.total_max_activations || 0}
              suffix="次"
            />
            <Statistic
              title="已使用配额"
              value={stats?.total_current_activations || 0}
              suffix="次"
              style={{ marginTop: 16 }}
            />
            <Statistic
              title="剩余配额"
              value={(stats?.total_max_activations || 0) - (stats?.total_current_activations || 0)}
              suffix="次"
              valueStyle={{ color: '#1890ff' }}
              style={{ marginTop: 16 }}
            />
          </Card>
        </Col>
        <Col span={12}>
          <Card title="使用说明">
            <ol style={{ paddingLeft: 20 }}>
              <li>在"序列号管理"页面创建新的序列号</li>
              <li>设置每个序列号的最大激活次数</li>
              <li>将序列号分发给用户</li>
              <li>用户在客户端使用序列号激活</li>
              <li>可在"硬件指纹"页面查看已激活设备</li>
            </ol>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default Dashboard;
